import { motion } from 'framer-motion';
import { Category } from '@/lib/types';

interface CategoryFilterProps {
  categories: Category[];
  active: string;
  onChange: (slug: string) => void;
}

export default function CategoryFilter({ categories, active, onChange }: CategoryFilterProps) {
  const all = [{ id: 0, slug: 'all', name: 'Wszystkie', icon: '⚡', sort_order: 0 }, ...categories];

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {all.map((cat) => {
        const isActive = active === cat.slug;
        return (
          <motion.button
            key={cat.slug}
            onClick={() => onChange(cat.slug)}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold tracking-wide transition-all duration-200 border"
            style={{
              fontFamily: 'Rajdhani, sans-serif',
              letterSpacing: '0.06em',
              background: isActive
                ? 'linear-gradient(135deg, var(--primary), var(--accent))'
                : 'oklch(0.16 0.03 280)',
              borderColor: isActive ? 'transparent' : 'oklch(0.25 0.045 280)',
              color: isActive ? 'white' : 'var(--muted-foreground)',
              boxShadow: isActive ? '0 0 18px oklch(0.65 0.32 280 / 0.4)' : 'none',
            }}
          >
            <span>{cat.icon}</span>
            <span>{cat.name}</span>
          </motion.button>
        );
      })}
    </div>
  );
}
